import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../shared/shared.module";
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import {MatTableModule} from '@angular/material/table';

import { ScheduleAppointmentRoutingModule } from './schedule-appointment-routing.module';
import { ScheduleAppointmentComponent } from './schedule-appointment.component';

export const MaterialModuleArr = [
  MatCardModule,
  MatButtonModule,
  MatChipsModule,
  MatTableModule
];


@NgModule({
  declarations: [ScheduleAppointmentComponent],

  imports: [
    CommonModule,
    ReactiveFormsModule,
  //  ScheduleAppointmentRoutingModule,
    MaterialModuleArr
  ],  

  exports: [
    MaterialModuleArr,
    ScheduleAppointmentRoutingModule,
    SharedModule
  ]
  
})
export class ScheduleAppointmentModule { }
